import * as React from "react";
import { createContext, useContext } from "react";
import styled, { css } from "styled-components";
import { components as ReactSelectComponents } from "react-select";
import { useTranslation } from "react-i18next";
import { InputList, InputDescription } from "components/common";
const SPLIT_PATTERN = /[\n,]/;
export const splitValues = (values) => {
  const seen = /* @__PURE__ */ new Set();
  return values.flatMap((value) => String(value).split(SPLIT_PATTERN)).map((value) => value.trim()).filter((value) => value.length > 0).filter((value) => {
    if (seen.has(value)) {
      return false;
    }
    seen.add(value);
    return true;
  });
};
const InvalidValuesContext = createContext({});
const AppendValuesContext = createContext(() => {
});
const InvalidValue = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
    text-decoration: underline wavy ${theme.colors.variant.danger};
  `
);
const ValueLabel = ({ data, children = null, ...props }) => {
  const invalid = useContext(InvalidValuesContext);
  const reason = invalid[String(data.value)];
  return /* @__PURE__ */ React.createElement(ReactSelectComponents.MultiValueLabel, { data, ...props }, reason ? /* @__PURE__ */ React.createElement(InvalidValue, { title: reason }, data.label) : children);
};
const PasteAndBlurInput = ({ value = "", onBlur = void 0, ...props }) => {
  const appendValues = useContext(AppendValuesContext);
  const handlePaste = (event) => {
    const text = event.clipboardData.getData("text");
    if (!SPLIT_PATTERN.test(text)) {
      return;
    }
    event.preventDefault();
    appendValues([text]);
  };
  const handleBlur = (event) => {
    var _a, _b;
    if (value) {
      (_b = (_a = props.selectProps).onKeyDown) == null ? void 0 : _b.call(_a, {
        key: "Enter",
        preventDefault: () => {
        }
      });
    }
    onBlur == null ? void 0 : onBlur(event);
  };
  return /* @__PURE__ */ React.createElement(ReactSelectComponents.Input, { ...props, value, onPaste: handlePaste, onBlur: handleBlur });
};
const SELECT_COMPONENTS = {
  DropdownIndicator: null,
  MultiValueLabel: ValueLabel,
  Input: PasteAndBlurInput
};
const WatchlistEntryValuesInput = ({ values, invalid, onChange, error = void 0 }) => {
  const { t } = useTranslation("enterprise_search");
  const handleChange = (event) => {
    var _a;
    onChange(splitValues((_a = event.target.value) != null ? _a : []));
  };
  const appendValues = (added) => onChange(splitValues([...values, ...added]));
  return /* @__PURE__ */ React.createElement(AppendValuesContext.Provider, { value: appendValues }, /* @__PURE__ */ React.createElement(InvalidValuesContext.Provider, { value: invalid }, /* @__PURE__ */ React.createElement(
    InputList,
    {
      id: "watchlist-entry-values",
      name: "watchlist-entry-values",
      label: t("watchlist_entry_values_input.label"),
      values,
      onChange: handleChange,
      help: t("watchlist_entry_values_input.help"),
      placeholder: t("watchlist_entry_values_input.placeholder"),
      components: SELECT_COMPONENTS
    }
  ), error ? /* @__PURE__ */ React.createElement(InputDescription, { error }) : null));
};
export default WatchlistEntryValuesInput;
